<template>
  <div class="py-12">
    <div class="center-content justify-center align-center">
      <h1>Top 100</h1>
      <v-card
        class="ranking mt-4"
        width="200"
      >
        <v-card-text>
          <v-row
            v-for="(record,recordKey) in records"
            :key="recordKey"
          >
            <v-col
              class="py-0"
              cols="8"
            >{{record.name}}</v-col>
            <v-col
              class="py-0 text-right"
              cols="4"
            >{{record.score}}</v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <router-link
        to="/"
        class="mt-5"
      >Back Home</router-link>
    </div>
  </div>
</template>
<script>
import firebase from "@/firebase";
export default {
  data() {
    return {
      records: [],
    };
  },
  methods: {
    async recordsGet() {
      this.records = [];
      const snapshot = await firebase.db
        .collection("records")
        .limit(100)
        .orderBy("score", "desc")
        .get();
      snapshot.forEach((record) => {
        this.records.push(record.data());
      });
    },
  },
  mounted() {
    this.recordsGet();
  },
};
</script>